import { injectable } from 'inversify';
import { action, computed, makeObservable, observable } from 'mobx';
import type { BannerVariant, BannerContent } from '@/components/banner/Banner';

@injectable()
export class BannerStore {
  @observable
  private _variant: BannerVariant | null = null;

  @observable
  private _content: BannerContent = '';

  @observable
  private _isVisible = false;

  public constructor() {
    makeObservable(this);
  }

  @computed
  public get variant(): BannerVariant | null {
    return this._variant;
  }

  @computed
  public get content(): BannerContent {
    return this._content;
  }

  @computed
  public get isVisible(): boolean {
    return this._isVisible;
  }

  @computed
  public get currentBanner(): { variant: BannerVariant; content: BannerContent } | null {
    if (!this._isVisible || !this._variant) {
      return null;
    }
    return {
      variant: this._variant,
      content: this._content
    };
  }

  @action
  public showBanner(variant: BannerVariant, content: BannerContent): void {
    this._variant = variant;
    this._content = content;
    this._isVisible = true;
  }

  @action
  public hideBanner(): void {
    this._isVisible = false;
    this._variant = null;
    this._content = '';
  }
}
